import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../../models/chips-and-fields';

@Component({
  selector: 'app-date-mobile',
  templateUrl: './dateMobile.component.html',
  styleUrls: ['./dateMobile.component.css']
})
export class DateMobileComponent implements OnInit {

  @Input() public field: Field;
  @Input() public parentFormGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
